import { Link } from "react-router-dom";

const STARFLOWER = "/api/uploads/art/starflower_pin_824405.png";

// Stars 4 Peace Giving Map badge — reusable anywhere. With onClick it acts as a filter toggle; otherwise it links to /give.
export const GivingMapBadge = ({ title = "Stars 4 Peace Giving Map", sub = "Seasonal Needs & Toys Drive", icon, onClick, active = false, to = "/give", className = "", testId = "giving-map-badge" }) => {
  const inner = (
    <>
      <span className={`relative h-11 w-11 shrink-0 rounded-full bg-white border-2 flex items-center justify-center overflow-hidden ${active ? "border-amber-500" : "border-[#F2CC8F]"}`}>
        <img src={icon || STARFLOWER} alt="" className="h-9 w-9 object-contain" />
      </span>
      <span className="min-w-0 text-left leading-tight">
        <span className="block text-[10px] font-extrabold uppercase tracking-[0.18em] text-[#F2CC8F]">{title}</span>
        <span className="block text-xs sm:text-sm font-bold text-white truncate">{sub}</span>
        {onClick && <span className="block text-[10px] text-white/75">{active ? "Showing giving locations only · tap for all" : "Tap to show giving locations"}</span>}
      </span>
    </>
  );
  const cls = `inline-flex items-center gap-2.5 rounded-full pl-1 pr-4 py-1 shadow-xl border-2 transition-colors ${active ? "bg-amber-700 border-amber-400" : "bg-[#0A1626]/95 border-[#F2CC8F]/70 hover:bg-[#12213a]"} ${className}`;
  if (onClick) return <button type="button" onClick={onClick} aria-pressed={active} className={cls} data-testid={testId}>{inner}</button>;
  if (!to) return <div className={cls} data-testid={testId}>{inner}</div>;
  return <Link to={to} className={cls} data-testid={testId}>{inner}</Link>;
};

export default GivingMapBadge;
